import { Directive, Input, Renderer2, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

const excludeList = [
    '/forum/categoria/1/unhide-contests'
]


const excludeUnhideContestConstant = 'unhide-contests';
@Directive({
    selector: '[unhMenuStateObserver]',
})
export class MenuStateObserverDirective {
    @Input() linkpath: any;
    @Input() hasInnerMenu;
    @Input() innerMenuList: Array<any>;


    constructor(
        private router: Router,
        private r2: Renderer2,
        private elref: ElementRef
    ) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(evt => {
            const event = evt as NavigationEnd;
            let isMatch;
            if (this.hasInnerMenu) {
                if (!excludeList.some(item => item == (event as NavigationEnd).url) && !event.url.includes(excludeUnhideContestConstant)) {
                    this.innerMenuList.forEach(element => {
                        isMatch = event.url == element.linkpath || event.url.match(/^(\/[^/]*)/)[0] == this.linkpath;
                    });
                }
            } else {
                isMatch = event.url === this.linkpath;
                if (event.url.includes(excludeUnhideContestConstant) && (this.linkpath == excludeList[0] || this.linkpath.includes('/forum'))) {
                    isMatch = true;
                }
            }

            if (isMatch) {
                this.r2.addClass(this.elref.nativeElement, 'activeLink');
            } else {
                this.r2.removeClass(this.elref.nativeElement, 'activeLink');
            }
        });
    }
}